import { BlockT, ModelBase, ModelUtils, Point } from "pytha";
import { DeviceModelBase } from "../interface/DeviceModelBase";


export class DeviceComponentT extends BlockT implements DeviceModelBase {
    type = 'DeviceComponentT';

    // 组件类型
    componentType: string;
    group: { [key: number]: string[] } = {};
    connected: boolean = false;

    constructor(componentType: string, position = new Point(), entities: ModelBase[] = [], name = '', normal = null, axisX = null, uuid = null) {
        super(position, entities, name, normal, axisX, uuid);
        this.componentType = componentType;
    }

    copy(block: BlockT): this;
    copy(component: DeviceComponentT): this;
    copy(block: any): this {
        super.copy(block); // 调用父类的 copy 方法
        if (block instanceof DeviceComponentT) {
            this.componentType = block.componentType; // 复制 DeviceComponentT 的特有属性
            this.group = block?.group;
            this.connected = block?.connected;
        }
        return this;
    }

    clone(): this {
        const component = new DeviceComponentT(this.componentType).copy(this) as this; // 创建新实例并复制属性
        component.uuid = ModelUtils.generateUUID(); // 生成新的 UUID
        return component;
    }

    toJson(rename: boolean = false) {
        const json = super.toJson();
        return {
            ...json,
            componentType: this.componentType,
            group: this.group,
            connected: this.connected,
        };
    }

    fromJson(json) {
        super.fromJson(json);
        this.componentType = json.componentType;
        this.connected = json.connected;
        this.group = json?.group ? json?.group : {}; //适配早期的图元没有该字段
        return this;
    }

}